import React from 'react';
import { PageHeader } from '../components/dashboard/PageHeader';
import { Card, CardContent } from '../components/Card';
import { TrendingUp, Target, Heart } from 'lucide-react';
import { Progress } from '../components/Progress';
import { Button } from '../components/Button';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';
const programs = [{
  name: 'Makan Bergizi Gratis (MBG)',
  short: 'MBG',
  reach: 78,
  sentiment: 72,
  controversy: 22,
  status: 'TINGGI',
  desc: 'Adopsi tinggi di Jawa & Sulawesi. Beberapa kritik soal kualitas distribusi.'
}, {
  name: 'Hilirisasi Nikel',
  short: 'NIKEL',
  reach: 64,
  sentiment: 58,
  controversy: 38,
  status: 'SEDANG',
  desc: 'Sentimen positif soal lapangan kerja, kritik soal dampak lingkungan.'
}, {
  name: 'Ibu Kota Nusantara (IKN)',
  short: 'IKN',
  reach: 82,
  sentiment: 42,
  controversy: 65,
  status: 'KRITIS',
  desc: 'Polarisasi tinggi terkait pembiayaan dan progress IKN tahap 2.'
}, {
  name: 'Subsidi BBM Tepat Sasaran',
  short: 'BBM',
  reach: 70,
  sentiment: 38,
  controversy: 58,
  status: 'TINGGI',
  desc: 'Keluhan dominan: implementasi MyPertamina dan kelancaran SPBU.'
}, {
  name: 'Bansos Pangan',
  short: 'BANSOS',
  reach: 85,
  sentiment: 45,
  controversy: 70,
  status: 'KRITIS',
  desc: 'Diserang hoaks pembatalan. Perlu klarifikasi data resmi.'
}, {
  name: 'Kartu Indonesia Pintar',
  short: 'KIP',
  reach: 55,
  sentiment: 78,
  controversy: 12,
  status: 'STABIL',
  desc: 'Apresiasi luas, isu minor terkait penyaluran daerah 3T.'
}];
const statusColor: Record<string, string> = {
  STABIL: 'text-emerald-500 bg-emerald-500/5 border-emerald-500/30',
  SEDANG: 'text-blue-500 bg-blue-500/5 border-blue-500/30',
  TINGGI: 'text-amber-500 bg-amber-500/5 border-amber-500/30',
  KRITIS: 'text-red-500 bg-red-500/5 border-red-500/30'
};
export function PolicyImpact() {
  const navigate = useNavigate();
  return <div className="mx-auto flex w-full max-w-[1600px] flex-col gap-6" data-id="element-2722">
      <PageHeader group="Stabilitas Nasional" title="Policy Impact Monitoring" description="Dampak program & kebijakan Presiden — adopsi publik, sentimen, dan tingkat kontroversi." icon={TrendingUp} data-id="element-2723" />

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-2724">
        {[{
        l: 'Program Dipantau',
        v: '12',
        i: Target,
        c: 'text-blue-500'
      }, {
        l: 'Sentimen Rata-rata',
        v: '56%',
        i: Heart,
        c: 'text-emerald-500'
      }, {
        l: 'Program Kritis',
        v: '2',
        i: TrendingUp,
        c: 'text-red-500'
      }].map(k => <Card key={k.l} className="bg-card border-border/50" data-id="element-2725">
            <CardContent className="p-4 flex items-center justify-between" data-id="element-2726">
              <div data-id="element-2727">
                <p className="font-mono text-[10px] uppercase text-muted-foreground" data-id="element-2728">
                  {k.l}
                </p>
                <p className={`font-heading text-2xl font-bold mt-1 ${k.c}`} data-id="element-2729">
                  {k.v}
                </p>
              </div>
              <k.i className={`size-6 ${k.c}`} data-id="element-2730" />
            </CardContent>
          </Card>)}
      </div>

      <div className="space-y-3" data-id="element-2731">
        {programs.map(p => <Card key={p.name} className={`bg-card border ${statusColor[p.status].split(' ')[2]}`} data-id="element-2732">
            <CardContent className="p-4 grid grid-cols-12 gap-4 items-center" data-id="element-2733">
              <div className="col-span-12 lg:col-span-3" data-id="element-2734">
                <span className="font-mono text-[10px] text-muted-foreground" data-id="element-2735">
                  PROGRAM
                </span>
                <h3 className="font-heading text-base font-bold" data-id="element-2736">{p.name}</h3>
                <span className={`font-mono text-[9px] inline-block mt-1 px-1.5 py-0.5 rounded border ${statusColor[p.status]}`} data-id="element-2737">
                  {p.status}
                </span>
              </div>

              <div className="col-span-12 lg:col-span-6 space-y-2" data-id="element-2738">
                <div data-id="element-2739">
                  <div className="flex justify-between font-mono text-[9px] mb-0.5" data-id="element-2740">
                    <span className="text-muted-foreground" data-id="element-2741">PUBLIC REACH</span>
                    <span data-id="element-2742">{p.reach}%</span>
                  </div>
                  <Progress value={p.reach} className="h-1.5" data-id="element-2743" />
                </div>
                <div data-id="element-2744">
                  <div className="flex justify-between font-mono text-[9px] mb-0.5" data-id="element-2745">
                    <span className="text-muted-foreground" data-id="element-2746">
                      SENTIMEN POSITIF
                    </span>
                    <span className="text-emerald-500" data-id="element-2747">{p.sentiment}%</span>
                  </div>
                  <div className="w-full h-1.5 bg-muted rounded-full overflow-hidden" data-id="element-2748">
                    <div className="h-full bg-emerald-500" style={{
                  width: `${p.sentiment}%`
                }} data-id="element-2749" />
                  </div>
                </div>
                <div data-id="element-2750">
                  <div className="flex justify-between font-mono text-[9px] mb-0.5" data-id="element-2751">
                    <span className="text-muted-foreground" data-id="element-2752">KONTROVERSI</span>
                    <span className="text-red-500" data-id="element-2753">{p.controversy}%</span>
                  </div>
                  <div className="w-full h-1.5 bg-muted rounded-full overflow-hidden" data-id="element-2754">
                    <div className="h-full bg-red-500" style={{
                  width: `${p.controversy}%`
                }} data-id="element-2755" />
                  </div>
                </div>
              </div>

              <div className="col-span-12 lg:col-span-3 flex flex-col gap-2" data-id="element-2756">
                <p className="text-[11px] text-muted-foreground leading-relaxed" data-id="element-2757">
                  {p.desc}
                </p>
                <Button size="sm" variant="outline" onClick={() => {
              toast.success(`Membuka War Room: ${p.short}`);
              navigate('/program-war-room', {
                state: {
                  program: p.name
                }
              });
            }} data-id="element-2758">
                  Buka War Room
                </Button>
              </div>
            </CardContent>
          </Card>)}
      </div>
    </div>;
}